import { token, layout, typography, element } from "@universityofmaryland/web-styles-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { withViewTimelineAnimation } from "@universityofmaryland/web-utilities-library/styles";
import { createCompositeCarouselBlocks } from "../elements/equal-width-items.js";
import { buttonColorsOnBlack } from "../elements/nav-button.js";
import "@universityofmaryland/web-token-library";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import "@universityofmaryland/web-utilities-library/events";
const BACKGROUND_TEXTURE = `<svg aria-hidden="true" width="1599" height="618" viewBox="0 0 1599 618" fill="none" xmlns="http://www.w3.org/2000/svg"
"><mask id="mask0_2135_11278" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1600" height="618"><rect width="1600" height="618" fill="#242424"></rect></mask><g mask="url(#mask0_2135_11278)"><g opacity="0.5"><mask id="mask1_2135_11278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-17" y="-56" width="1823" height="408"><path d="M-17 351.98V-56H1806V351.98" fill="white"></path></mask><g mask="url(#mask1_2135_11278)"><path d="M807.562 -68.3515L-433.759 1173.58L-217.501 1389.94L1023.82 148.012L807.562 -68.3515Z" fill="#262626"></path><path d="M360.649 -82.8017L-880.672 1159.13L-649.997 1389.92L591.324 147.986L360.649 -82.8017Z" fill="black"></path><path d="M1154.8 1173.26L-533.139 -515.499L-677.311 -371.256L1010.63 1317.51L1154.8 1173.26Z" fill="#262626"></path><path d="M2162.77 710.525L1312.18 -140.478L1168.01 3.76505L2018.6 854.768L2162.77 710.525Z" fill="black"></path><path d="M1312.16 -140.485L202.096 -1251.09L57.9241 -1106.85L1167.99 3.75794L1312.16 -140.485Z" fill="#EDEDED"></path><path d="M2133.89 -1251.07L1023.83 -140.458L1168 3.78455L2278.07 -1106.83L2133.89 -1251.07Z" fill="#383838"></path><path d="M591.343 147.968L-634.061 -1078.04L-864.736 -847.248L360.668 378.756L591.343 147.968Z" fill="black"></path><path d="M1023.82 147.97L-217.503 -1093.96L-433.761 -877.595L807.559 364.333L1023.82 147.97Z" fill="#383838"></path></g><mask id="mask2_2135_11278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-17" y="351" width="1823" height="780"><path d="M-17 351.938V753.629L837.67 753.672L845.662 1130.18L1806 1130.26V352.094" fill="white"></path></mask><g mask="url(#mask2_2135_11278)"><path d="M1023.81 555.952L-217.506 -685.977L-433.764 -469.613L807.557 772.316L1023.81 555.952Z" fill="#262626"></path><path d="M591.347 555.967L-649.973 -685.962L-880.648 -455.174L360.672 786.755L591.347 555.967Z" fill="black"></path><path d="M1010.63 -613.543L-677.305 1075.22L-533.133 1219.46L1154.8 -469.3L1010.63 -613.543Z" fill="#262626"></path><path d="M1760.63 110.929L910.039 961.932L1054.21 1106.17L1904.8 255.172L1760.63 110.929Z" fill="black"></path><path d="M360.674 325.168L-864.73 1551.17L-634.055 1781.96L591.349 555.956L360.674 325.168Z" fill="black"></path><path d="M807.565 339.631L-433.756 1581.56L-217.498 1797.92L1023.82 555.995L807.565 339.631Z" fill="#383838"></path></g></g></g></svg>`;
const ANIMATION_NAME = "card-carousel-slide-in";
const KEYFRAMES = `
  @keyframes ${ANIMATION_NAME} {
    from { transform: translateX(-25vw); }
    to { transform: translateX(0); }
  }
`;
const CreateIntro = (props) => {
  const { headline, text, actions } = props;
  const createHeadline = () => {
    if (!headline) return null;
    return new ElementBuilder(headline).withClassName("carousel-cards-intro-container-headline").styled(typography.sans.largest).withStyles({
      element: {
        color: token.color.white,
        fontWeight: token.font.weight.extraBold,
        textTransform: "uppercase",
        "& *": {
          color: token.color.white,
          fontWeight: token.font.weight.extraBold,
          textTransform: "uppercase"
        }
      }
    });
  };
  const createText = () => {
    if (!text) return null;
    return new ElementBuilder(text).withClassName("carousel-cards-intro-container-text").styled(element.text.rich.simpleDark).styled(typography.sans.medium).withStyles({
      element: {
        "* + &": { marginTop: token.spacing.md }
      }
    });
  };
  const createActions = () => {
    if (!actions) return null;
    return new ElementBuilder(actions).withClassName("carousel-cards-intro-container-cta").withStyles({
      element: {
        "* + &": { marginTop: token.spacing.md },
        "& a": { color: token.color.white }
      }
    });
  };
  const wrapperChildren = [
    createHeadline(),
    createText(),
    createActions()
  ].filter((child) => child !== null);
  const wrapperModel = new ElementBuilder().withClassName("carousel-cards-intro-container-lock").withStyles({
    element: {
      [`@media (${token.media.queries.desktop.min})`]: {
        maxWidth: "inherit",
        padding: 0
      }
    }
  }).withChildren(...wrapperChildren).build();
  return new ElementBuilder().withClassName("carousel-cards-intro-container").withStyles({
    element: {
      marginBottom: token.spacing.md,
      [`@container (${token.media.queries.desktop.min})`]: {
        width: `calc(40% - ${token.spacing["2xl"]})`,
        paddingRight: token.spacing["2xl"],
        marginBottom: 0
      }
    }
  }).withChild(wrapperModel).build();
};
const createCompositeCarouselCards = (props) => (() => {
  const { slide, shadowRef } = props;
  if (slide) {
    slide.style.minHeight = "360px";
  }
  if (shadowRef) {
    shadowRef.style.minHeight = "360px";
  }
  const carouselContainer = createCompositeCarouselBlocks.CreateElement({
    slide: props.slide,
    shadowRef: props.shadowRef,
    blocks: props.cards,
    mobileBreakpoint: token.media.breakpointValues.large.min,
    tabletBreakpoint: token.media.breakpointValues.desktop.min,
    desktopBreakpoint: token.media.breakpointValues.desktop.min,
    mobileCount: 1,
    tabletCount: 2,
    desktopCount: 2,
    maxCount: 2,
    showMobileHint: true,
    showHint: false,
    button: {
      ...buttonColorsOnBlack(),
      outsetOffset: "52px"
    }
  });
  const carouselWrapperModel = new ElementBuilder().withClassName("carousel-cards-block-wrapper").withStyles({
    element: {
      [`@container (${token.media.queries.desktop.min})`]: {
        width: "60%"
      }
    }
  }).withChild(carouselContainer).build();
  const introModel = CreateIntro(props);
  const wrapperModel = new ElementBuilder().withClassName("element-carousel-lock").styled(layout.space.horizontal.larger).withStyles({
    element: {
      position: "relative",
      paddingRight: 0,
      [`@media (${token.media.queries.tablet.min})`]: {
        paddingRight: token.spacing["2xl"]
      },
      [`@media (${token.media.queries.highDef.min})`]: {
        paddingRight: token.spacing["4xl"]
      },
      [`@media (${token.media.queries.desktop.min})`]: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }
  }).withChildren(introModel, carouselWrapperModel).build();
  const containerModel = new ElementBuilder().withClassName("element-carousel-container").withStyles({
    element: {
      backgroundColor: token.color.black,
      padding: `${token.spacing["3xl"]} 0`,
      position: "relative",
      overflow: "clip",
      "& > svg": {
        width: "auto",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        top: 0,
        ...withViewTimelineAnimation({
          animation: `${ANIMATION_NAME} ease-in-out forwards`,
          animationTimeline: "view()",
          animationRangeStart: "0",
          animationRangeEnd: "100vh",
          transform: "translateX(-15vw)"
        })
      },
      "@container (max-width: 300px)": { display: "none" },
      [`@container (${token.media.queries.tablet.min})`]: {
        padding: `${token.spacing["4xl"]} 0`
      },
      [`@container (${token.media.queries.desktop.min})`]: {
        padding: `${token.spacing["max"]} 0`
      }
    }
  }).withChild(wrapperModel).withModifier((element2) => {
    element2.insertAdjacentHTML("afterbegin", BACKGROUND_TEXTURE);
  }).build();
  containerModel.styles += KEYFRAMES;
  const declarationModel = new ElementBuilder().withClassName("carousel-cards-declaration").withStyles({
    element: {
      containerType: "inline-size",
      "& *": { color: token.color.white }
    }
  }).withChild(containerModel).withEvents({
    resize: carouselContainer.events.resize,
    load: carouselContainer.events.load
  }).build();
  return declarationModel;
})();
export {
  createCompositeCarouselCards
};
//# sourceMappingURL=index.js.map
